var map = {
	"./AdminBuilder": 50,
	"./AdminBuilder.js": 50,
	"./Modal": 13,
	"./Modal/": 13,
	"./Modal/Modal": 41,
	"./Modal/Modal.jsx": 41,
	"./Modal/index": 13,
	"./Modal/index.jsx": 13,
	"./PageRender": 51,
	"./PageRender.js": 51,
	"./ProjectGrid": 52,
	"./ProjectGrid.js": 52,
	"./ProjectModal": 8,
	"./ProjectModal/": 8,
	"./ProjectModal/ModalContent": 14,
	"./ProjectModal/ModalContent.js": 14,
	"./ProjectModal/ProjectInfo": 43,
	"./ProjectModal/ProjectInfo.js": 43,
	"./ProjectModal/ProjectModal": 42,
	"./ProjectModal/ProjectModal.js": 42,
	"./ProjectModal/SimilarProjects": 69,
	"./ProjectModal/SimilarProjects.js": 69,
	"./ProjectModal/VideoSlide": 44,
	"./ProjectModal/VideoSlide.js": 44,
	"./ProjectModal/VrSlide": 45,
	"./ProjectModal/VrSlide.js": 45,
	"./ProjectModal/index": 8,
	"./ProjectModal/index.js": 8,
	"./ProjectPage": 70,
	"./ProjectPage.js": 70,
	"./admin/ImagePicker": 71,
	"./admin/ImagePicker.js": 71,
	"./admin/MenuEditor": 72,
	"./admin/MenuEditor.js": 72,
	"./pickers/VideoPicker": 12,
	"./pickers/VideoPicker/": 12,
	"./pickers/VideoPicker/VideoPicker": 31,
	"./pickers/VideoPicker/VideoPicker.jsx": 31,
	"./pickers/VideoPicker/index": 12,
	"./pickers/VideoPicker/index.js": 12,
	"./widgets": 7,
	"./widgets/": 7,
	"./widgets/ArticleTitleWidget": 28,
	"./widgets/ArticleTitleWidget.jsx": 28,
	"./widgets/HtmlWidget": 38,
	"./widgets/HtmlWidget.jsx": 38,
	"./widgets/ImageWidget": 20,
	"./widgets/ImageWidget.jsx": 20,
	"./widgets/LeadImageWidget": 23,
	"./widgets/LeadImageWidget.jsx": 23,
	"./widgets/MosaicFullWidget": 33,
	"./widgets/MosaicFullWidget.jsx": 33,
	"./widgets/MosaicHalfWidget": 34,
	"./widgets/MosaicHalfWidget.jsx": 34,
	"./widgets/MosaicItem": 5,
	"./widgets/MosaicItem.jsx": 5,
	"./widgets/MosaicOneTwoWidget": 36,
	"./widgets/MosaicOneTwoWidget.jsx": 36,
	"./widgets/MosaicThirdWidget": 35,
	"./widgets/MosaicThirdWidget.jsx": 35,
	"./widgets/MosaicVerticalWidget": 37,
	"./widgets/MosaicVerticalWidget.jsx": 37,
	"./widgets/NavigationWidget": 24,
	"./widgets/NavigationWidget.jsx": 24,
	"./widgets/PageTitleWidget": 27,
	"./widgets/PageTitleWidget.jsx": 27,
	"./widgets/SectionTitleWidget": 19,
	"./widgets/SectionTitleWidget.jsx": 19,
	"./widgets/SloganWidget": 25,
	"./widgets/SloganWidget.jsx": 25,
	"./widgets/StatsWidget": 29,
	"./widgets/StatsWidget.jsx": 29,
	"./widgets/TeamWidget/VideoThumb": 32,
	"./widgets/TeamWidget/VideoThumb.jsx": 32,
	"./widgets/TestimonialWidget": 26,
	"./widgets/TestimonialWidget.jsx": 26,
	"./widgets/TextBoxWidget": 21,
	"./widgets/TextBoxWidget.jsx": 21,
	"./widgets/ThumbsWidget": 30,
	"./widgets/ThumbsWidget.jsx": 30,
	"./widgets/TourWidget": 40,
	"./widgets/TourWidget.jsx": 40,
	"./widgets/VideoWidget": 22,
	"./widgets/VideoWidget.jsx": 22,
	"./widgets/VrWidget": 39,
	"./widgets/VrWidget.jsx": 39,
	"./widgets/index": 7,
	"./widgets/index.jsx": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;